import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ReactMarkdown from 'react-markdown';

import FormInputWrapper from '../form-input-wrapper/FormInputWrapper.jsx';

const FormSectionDivider = ({
  sectionContent,
  linkTargetBlank,
  parentElementClass,
  additionalInputs,
  autoPopulate,
  triggerValidation,
  formStepValidation
  }) => {
  const [ showAdditional, setShowAdditional ] = useState(false);
  const [ markdownComponents, setMarkdownComponents ] = useState({});


  /**
   * When the component has been mounted
   */
  useEffect(() => {
    // Set overrides for markdown rendering
    const markdownCustomComponents = {
      blockquote: BlockquoteRenderer,
      ul: UnorderedListRenderer
    };

    if (linkTargetBlank) {
      markdownCustomComponents.a = LinkRenderer;
    }

    setMarkdownComponents(markdownCustomComponents);
  }, []);

  const onAdditionalButtonClick = (evt) => {
    evt.preventDefault();

    if (!showAdditional) {
      setShowAdditional(true);
    } else {
      setShowAdditional(false);
    }
  };

  function LinkRenderer(linkProps) {
    return (
      <a href={linkProps.href} target="_blank" rel="noopener noreferrer">
        {linkProps.children}
      </a>
    );
  }

  function BlockquoteRenderer(linkProps) {
    return (
      <blockquote className="highlight">
        {linkProps.children}
      </blockquote>
    );
  }

  function UnorderedListRenderer(linkProps) {
    return (
      <ul className="custom-form__unordered-list">
        {linkProps.children}
      </ul>
    );
  }

  return (
    <div className={parentElementClass}>
      {
        (
          sectionContent !== undefined &&
          sectionContent !== null &&
          sectionContent !== ""
        ) ?
          <ReactMarkdown
            components={ markdownComponents }>
              {sectionContent}
          </ReactMarkdown>
        : null
      }
      {
        (additionalInputs && !showAdditional) ? <button onClick={onAdditionalButtonClick} className="btn btn-primary form-add-section__button">{additionalInputs.buttonLabelAdd}</button> : null
      }
      {
        (showAdditional) ?
          <div className="form_optional-section-container form-columns">
            <div className="form-question-wrapper">
              <button onClick={onAdditionalButtonClick} className="btn btn-outline form-remove-section__button">{additionalInputs.buttonLabelRemove}</button>
            </div>
            {
              additionalInputs.inputs.map( (formInput, index) => {
                return (
                  <FormInputWrapper
                    key={index}
                    inputConfiguration={formInput}
                    autoPopulate={autoPopulate}
                    triggerValidation={triggerValidation}
                    formStepValidation={formStepValidation}
                  />
                );
              })
            }
          </div>
        : null
      }
    </div>
  );
};

FormSectionDivider.propTypes = {
  "sectionContent": PropTypes.string,
  "linkTargetBlank": PropTypes.bool,
  "parentElementClass": PropTypes.string,
  "additionalInputs": PropTypes.object,
  "autoPopulate": PropTypes.bool,
  "triggerValidation": PropTypes.object,
  "formStepValidation": PropTypes.number.isRequired,
};

export default FormSectionDivider;